import React from "react";

const CLIENTS = [
  {
    name: "Grupo Vidanta",
    tag: "Nayarit · Puerto Peñasco · Cancún · Acapulco",
    desc: "Malla ciclónica, reja de acero, herrería y estructuras metálicas perimetrales.",
  },
  {
    name: "Tierra Tropical",
    tag: "Constructora · Industria",
    desc: "Cercado industrial, herrería arquitectónica y estructuras metálicas.",
  },
  {
    name: "Black Palm — St. Regis",
    tag: "Punta de Mita",
    desc: "Reja de acero y herrería especializada en desarrollo de lujo.",
  },
  {
    name: "Four Seasons",
    tag: "Hoteles & Resorts",
    desc: "Estructuras metálicas y precisión en herrería arquitectónica.",
  },
  {
    name: "Grupo Aeroportuario del Pacífico",
    tag: "GAP · Infraestructura",
    desc: "Soluciones perimetrales para infraestructura aeroportuaria.",
  },
];

const Projects = () => {
  const marqueeItems = [...CLIENTS, ...CLIENTS];

  return (
    <section
      id="proyectos"
      data-testid="projects-section"
      className="relative bg-[#EAE6D8] py-24 md:py-32 border-t-2 border-[#0A0A0A] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-mono-tag text-xs text-[#0A0A0A] mb-4">// PROYECTOS</p>
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-8">
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.9] text-[#0A0A0A]">
              PROYECTOS Y
              <br />
              <span className="text-[#F5E60F]">CLIENTES</span> DESTACADOS.
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-[#3A3A3A]">
              Marcas líderes que han confiado en Alambrados Aloma para asegurar
              proyectos de alto perfil en hotelería, industria e infraestructura.
            </p>
          </div>
        </div>
      </div>

      {/* Marquee row */}
      <div className="relative w-full overflow-hidden border-y-2 border-[#005EB8] bg-[#005EB8] py-6 mb-12">
        <div className="flex marquee-track whitespace-nowrap gap-12">
          {marqueeItems.map((c, i) => (
            <span
              key={`${c.name}-${i}`}
              className="font-display text-5xl md:text-7xl text-transparent"
              style={{ WebkitTextStroke: "1px #FFF44F" }}
            >
              {c.name} <span className="text-[#FFF44F]" style={{ WebkitTextStroke: "0px" }}>★</span>
            </span>
          ))}
        </div>
      </div>

      {/* Cards grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-[#0A0A0A] bg-[#FAFAF5]">
          {CLIENTS.map((c, idx) => (
            <div
              key={c.name}
              data-testid={`project-card-${idx}`}
              className="group border-r border-b border-[#0A0A0A] p-8 hover:bg-[#FFF44F] transition-colors"
            >
              <div className="flex items-start justify-end mb-4">
                <span className="w-8 h-1 hazard-stripes" />
              </div>
              <h3 className="font-display text-2xl md:text-3xl mb-2 text-[#0A0A0A]">
                {c.name}
              </h3>
              <p className="font-mono-tag text-[10px] text-[#F5E60F] group-hover:text-[#0A0A0A] mb-4 transition-colors">
                {c.tag}
              </p>
              <p className="text-sm text-[#3A3A3A] leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 border-2 border-[#0A0A0A] bg-[#FFF44F] p-8 md:p-12 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <p className="font-mono-tag text-xs text-[#0A0A0A] mb-2">// CONTRATA A ALAMBRADOS ALOMA</p>
            <p className="font-display text-3xl md:text-4xl leading-tight text-[#0A0A0A]">
              ¿LISTO PARA COMENZAR TU PROYECTO?
            </p>
          </div>
          <button
            data-testid="projects-cta"
            onClick={() => {
              const el = document.getElementById("contacto");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="bg-[#0A0A0A] text-[#FFF44F] px-8 py-5 font-bold uppercase tracking-widest text-sm hover:bg-white hover:text-[#0A0A0A] transition-colors whitespace-nowrap border-2 border-[#0A0A0A]"
          >
            Iniciar Cotización
          </button>
        </div>
      </div>
    </section>
  );
};

export default Projects;
